import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'user-change-password-desktop',
    templateUrl: './change-password-desktop.component.html',
    styleUrls: ['./change-password-desktop.component.scss'],
    standalone: false
})
export class ChangePasswordDesktopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
